import { SET_AUTHENTICATION_STATE } from '../actions/index'

const initialState = {
  userProfile: null
}
const authenticationState = (state = initialState, action) => {
  switch (action.type) {
    case SET_AUTHENTICATION_STATE:
      return { ...state, userProfile: action.profile }

    default:
      return state
  }
}

export default authenticationState
